import $ from 'jquery';

// Mobile Offcanvas Menus: main and mega panels
$(function () {
  const $body = $('body');
  const $overlay = $('.js-mobile-overlay');
  const $hamburger = $('.navbar-right-mobile .btn-hamburger');
  const $main = $('#mobile-menu');
  const $mega = $('#mobile-mega');
  const $megaBody = $mega.find('.js-mega-body');
  const $megaTitle = $mega.find('.js-mega-title');

  if (!$main.length || !$hamburger.length) return;

  let lastFocus = null; // to restore on close

  // Utils
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function setAriaOpen($el, isOpen) {
    $el.attr('aria-hidden', isOpen ? 'false' : 'true');
    $el.toggleClass('is-open', isOpen);
  }

  function showOverlay(show) {
    $overlay.attr('aria-hidden', show ? 'false' : 'true').toggleClass('is-visible', show);
    $body.toggleClass('has-mobile-menu-open', show);
  }

  function trapFocus($container, e) {
    const $focusables = $container.find(FOCUSABLE).filter(':visible');
    if (!$focusables.length) return;
    const $first = $focusables.first();
    const $last = $focusables.last();

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if ($(document.activeElement).is($first)) {
          e.preventDefault();
          $last.trigger('focus');
        }
      } else {
        if ($(document.activeElement).is($last)) {
          e.preventDefault();
          $first.trigger('focus');
        }
      }
    }
  }

  function focusFirst($container) {
    const $focusables = $container.find(FOCUSABLE).filter(':visible');
    if ($focusables.length) {
      $focusables.first().trigger('focus');
    } else {
      $container.attr('tabindex', '-1').trigger('focus');
    }
  }

  // Open/Close main panel
  function openMain() {
    lastFocus = document.activeElement;
    setAriaOpen($main, true);
    showOverlay(true);
    focusFirst($main);
  }
  function closeMain({ restoreFocus = true } = {}) {
    setAriaOpen($main, false);
    // Also close mega if open
    setAriaOpen($mega, false);
    showOverlay(false);
    if (restoreFocus && lastFocus) $(lastFocus).trigger('focus');
  }

  // Open/Close mega panel
  function openMega(megaId, title) {
    // Inject content
    const $tpl = $(`.mobile-mega-template[data-mega-id="${megaId}"]`);
    $megaBody.empty();
    if ($tpl.length) {
      // clone children to keep template hidden intact
      $tpl.children().clone(true, true).appendTo($megaBody);
    }
    if (title) {
      $megaTitle.text(title).attr({ role: 'heading', 'aria-level': '2' });
    } else {
      $megaTitle.text('').removeAttr('role aria-level');
    }
    setAriaOpen($mega, true);
    focusFirst($mega);
  }
  function closeMega() {
    setAriaOpen($mega, false);
    $megaTitle.text('').removeAttr('role aria-level');
    focusFirst($main);
  }

  // Events
  $hamburger.on('click', function () {
    const isOpen = $main.hasClass('is-open');
    if (isOpen) closeMain();
    else openMain();
  });

  // Open mega from main list
  $(document).on('click', '.js-open-mega', function () {
    const megaId = $(this).data('mega-id');
    const title = $(this).data('mega-title');
    openMega(megaId, title);
  });

  // Back from mega to main
  $mega.on('click', '.js-mega-back', function () {
    closeMega();
  });

  // Close buttons
  $(document).on('click', '.js-close-mobile-menu', function () {
    closeMain();
  });

  // Click on overlay closes all
  $overlay.on('click', function () {
    closeMain();
  });

  // ESC to close (when any panel is open)
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc' || e.which === 27) {
      if ($mega.hasClass('is-open')) {
        closeMega();
      } else if ($main.hasClass('is-open')) {
        closeMain();
      }
    }
  });

  // Focus trap inside open panel
  $(document).on('keydown', function (e) {
    if ($mega.hasClass('is-open')) {
      trapFocus($mega, e);
    } else if ($main.hasClass('is-open')) {
      trapFocus($main, e);
    }
  });
});

